<template functional>
  <span :aria-hidden="props.decorative"
        :aria-label="props.title"
        :class="[data.class, data.staticClass]"
        class="material-design-icon filter-menu-icon"
        role="img"
        v-bind="data.attrs"
        v-on="listeners">
    
    <svg :fill="props.fillColor"
         class="material-design-icon__svg"
         :width="props.size"
         :height="props.size" viewBox="0 0 145 137.15">
         <path d="M107.07,55.93A14.37,14.37,0,1,0,121.44,70.3,14.36,14.36,0,0,0,107.07,55.93ZM72.88,15.08A14.37,14.37,0,1,0,87.24,29.44,14.36,14.36,0,0,0,72.88,15.08ZM44.14,94.71a14.37,14.37,0,1,0,14.37,14.36A14.36,14.36,0,0,0,44.14,94.71ZM92.71,70.29H11.09m123.57,0H121.44M58.78,32.23H11.09m123.57,0H87M29.82,110.07H11.09m123.57,0H58.48" fill="none" :stroke="props.fillColor" stroke-miterlimit="10" stroke-width="10"/>
</svg>


  </span>
</template>

<script>
export default {
  name: "FilterMenuIcon",
  props: {
    title: {
      type: String,
      default: "Filter Menu icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>
